module.exports = __webpack_public_path__ + "media/images/common/logo_bg_10-ff0a12b2093e638efba41e3f494583b7.png";